import {Doctor} from "../doctor";
import {AssignType} from "../list-item";
import {Chain} from "../found-measurement";

export function generateAssignedDoctorLabel(
  measurement: {
    doctor: Doctor | undefined;
    chain: Chain | undefined;
    assignType: AssignType | undefined;
  },
  globalTechnicianPoolLabelLong: string,
  globalTechnicianPoolLabelShort: string,
): string {
  switch (measurement.assignType!) {
    case "DOCTOR":
      return `${measurement.doctor!.firstName} ${measurement.doctor!.lastName}`;
    case "GLOBAL_TECHNICIAN_POOL":
      return measurement.doctor
        ? `${measurement.doctor!.firstName} ${measurement.doctor!.lastName} (${globalTechnicianPoolLabelShort})`
        : globalTechnicianPoolLabelLong;
    case "CHAIN":
      if (measurement.doctor !== undefined) {
        return `${measurement.doctor!.firstName} ${measurement.doctor!.lastName} (${measurement.chain!.name})`;
      } else {
        return measurement.chain!.name;
      }
  }
}
